/* eslint-disable */

export const enum RoleType {
  customer = 1,
  mandant = 2,
  zvoove = 3,
  partner = 4,
}
